import React, { useState } from 'react'
import { Dialog, DialogBody } from '@blueprintjs/core'
import { PencilSimple, X } from 'phosphor-react'

import { InboxPreviewCard } from './component'

export function InboxPreview(props) {
  let [isOpen, setIsOpen] = useState(false)

  function closeModal() {
    setIsOpen(false)
  }

  function openModal() {
    setIsOpen(true)
  }

  const { editor, formatMessage, ...restProps } = props

  return (
    <div className="gan-subject gan-tw">
      {/* min-w-0 and truncate: line-clamp only cuts wrapped lines, so a
          subject with no spaces (a long URL) ran across the header. */}
      <button
        onClick={openModal}
        className="flex min-w-0 items-center gap-2 rounded px-3 py-2 font-semibold hover:bg-white/5"
        data-test="gan-subject__text"
        title={props.editor.subject}
      >
        <span className="truncate">{props.editor.subject}</span>
        <PencilSimple className="min-w-[15px] text-blue-300" size={15} />
      </button>

      <Dialog
        {...restProps}
        isOpen={isOpen}
        onClose={closeModal}
        transitionName="ease-out"
        className="gan-subject__modal gan-tw"
      >
        <DialogBody>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <div className="relative w-full max-w-4xl transform overflow-hidden rounded-lg bg-white text-left align-middle shadow-xl transition-all md:rounded-2xl">
                <button
                  className="absolute right-1.5 top-1.5 z-50 rounded-full p-1 hover:text-gray-900"
                  onClick={closeModal}
                >
                  <X weight="bold" size={14} />
                </button>
                <InboxPreviewCard
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  editor={props.editor}
                  formatMessage={props.formatMessage}
                />
              </div>
            </div>
          </div>
        </DialogBody>
      </Dialog>
    </div>
  )
}
